import { ICountryCodeDropdownOption } from "@Utils/location";

export const FORM_FIELDS = {
    name: "full_name",
    email: "email",
    phone: "phone_number",
    country: "country",
    message: "message",
    leadAnswers: "lead_answers",
    lead_answer_thumbnails: "lead_answer_thumbnails",
};

export interface IFormFields {
    name: string;
    email: string;
    phone: string;
    message: string;
    country: ICountryCodeDropdownOption;
    lead_answer_thumbnails: { [key: string]: string };
}

export interface IFormEnum {
    [k: string]: {
        id: string;
        label: string;
        key: string;
        validate?: (
            d: string,
            i?: boolean,
            isInternationalCreator?: boolean
        ) => string | null;
        inputType?: "text" | "number" | "textarea" | "tel" | "email";
        params?: any;
    };
}
